import ajax from 'ajax'
import PhoneComUser from 'phone-com-user'
import { getPhoneCom } from 'phonecom'
class API {
	static getConfig = async (offset, limit, filters, sort) => {
		let requestUrl = `${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/get-config`
		let response = await ajax.get(requestUrl)
		return response.data
	}

	static enableConfig = (enabled, domain, business) => {
		let requestUrl = `${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/enable`
		return ajax.post(requestUrl, { domain: domain, business_name: business }).then(response => response.data)
	}

	static disableConfig = reasons => {
		let requestUrl = `${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/disable`
		return ajax.post(requestUrl, {reasons}).then(response => response.data)
	}

	static updateConfig = async (enabled, domain, business_name, plan_code) => {
		console.log('req: ', { enabled, domain, business_name, plan_code })
		let requestUrl = `${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/update-config`
		let response = await ajax.post(requestUrl, { domain, business_name, plan_code })

		if(response.data){
			return response.data
		}
		return response
	}

	static addUser = (name, email, voip_phone_id, plan_code) => {
		return getPhoneCom().then(phonecom => {


			let myHeaders = new Headers();
			myHeaders.append('Authorization', `CP ${phonecom.cp_token}`);
			let account_id = PhoneComUser.getAPIAccountId()
			let raw = JSON.stringify({account_id, extension_id: voip_phone_id, name, email, plan_code});

			myHeaders.append('Content-Type', 'application/json');
				let requestOptions = {
				  method: 'POST',
				  headers: myHeaders,
				  body: raw,
				  redirect: 'follow'
				};
				return fetch(`${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/add-user`, requestOptions)
                .then(response => {
                	console.log(response)
                	return response.json()})
                .catch(error => console.log('error', error));
		})
	}

	static removeUser = (voip_phone_id) => {
		return getPhoneCom().then(phonecom => {


			let myHeaders = new Headers();
			console.log(phonecom)
			myHeaders.append("Authorization", `CP ${phonecom.cp_token}`);
			let raw = JSON.stringify({"account_id":parseInt(phonecom.voip_id), "extension_id":voip_phone_id});
				console.log(raw)
			myHeaders.append("Content-Type", "application/json");
				let requestOptions = {
				  method: 'POST',
				  headers: myHeaders,
				  body: raw,
				};
				return fetch(`${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/remove-user`, requestOptions)
                .then(response => {
                	console.log(response)
                	return response.json()})
                .catch(error => console.log('error', error));
		})
	}

	static listUsers = () => {
		return getPhoneCom().then(phonecom => {
			let requestUrl = `${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/list-users`
			return ajax.get(requestUrl).then(response => response.data)
		})
	}
	static removeUser = (voip_phone_id) => {
		return getPhoneCom().then(phonecom => {

			let myHeaders = new Headers();
			myHeaders.append("Authorization", `CP ${phonecom.cp_token}`);
			let raw = JSON.stringify({"extension_id":voip_phone_id});

			myHeaders.append("Content-Type", "application/json");
				let requestOptions = {
				  method: 'POST',
				  headers: myHeaders,
				  body: raw,
				  redirect: 'follow'
				};
				return fetch(`${PhoneComUser.getv5ApiRoot().replace('services', 'app')}/unified/video/remove-user`, requestOptions)
                .then(response => {
                	console.log(response)
					return response.json()
				})
                .catch(error => console.log('error', error));
		})
	}

}

export default API